<div data-testid="batch-page" class="p-6 batch-container flex-table-page">
  <!-- Header -->
  <div class="mb-6 flex-table-header">
    <h2 class="text-2xl font-semibold text-gray-800">
      {{ "batch_management.title" | translate }}
    </h2>
  </div>

  <!-- Search Form -->
  <app-search-form
    data-testid="batch-search-form"
    [searchFormat]="searchConfig()"
    (formSearch)="onSearch($event)"
    (formReset)="onReset()"
  >
    <div slot="actions" class="flex gap-2">
      <app-button
        [testId]="'batch-column-config-btn'"
        type="success"
        [outlined]="true"
        icon="view_column"
        (emitOnClick)="onColumnConfigClick($event)"
      ></app-button>
    </div>
  </app-search-form>

  <!-- Data Table -->
  <div class="flex-table-section">
    <advanced-data-table
      data-testid="batch-table"
      #advancedTable
      [dataSource]="batches()"
      [defaultColumns]="defaultColumns()"
      [flexibleColumns]="flexibleColumns()"
      [rows]="searchParams().size"
      [first]="(searchParams().page - 1) * searchParams().size"
      [totalRecords]="totalRecords()"
      [loading]="loading()"
      [showInternalColumnConfigButton]="false"
      scrollHeight="flex"
      (pageChange)="onPageChange($event)"
    >
    <ng-template #statusTemplate let-status>
      <div class="flex items-center justify-center gap-1 w-full">
        <p-tag
          data-testid="batch-status-tag"
          [value]="formatStatus(status)"
          [severity]="getStatusSeverity(status)"
          styleClass="status-tag"
          size="small"
        />
      </div>
    </ng-template>

    <ng-template
      #customTemplate
      let-value
      let-record="rowData"
      let-column="column"
    >
      @if (
        column.prop === "manufactureDate" ||
        column.prop === "expiryDate" ||
        column.prop === "creationDate"
      ) {
        {{ formatDate(value) }}
      } @else if (column.prop === "qty") {
        <div class="flex items-center justify-end">
          {{ value }}
        </div>
      } @else {
        {{ value }}
      }
    </ng-template>

    <ng-template #actionsTemplate let-record>
      <div class="flex gap-2 justify-center flex-wrap">
        @if (canRead()) {
          <span
            [attr.data-testid]="'batch-action-view-' + record.id"
            (click)="onViewDetails(record)"
            class="action-link action-edit cursor-pointer"
          >
            {{ "batch_management.actions.view" | translate }}
          </span>
        }
        @if (canUpdate()) {
          <span
            [attr.data-testid]="'batch-action-edit-' + record.id"
            (click)="openEditExpiry(record)"
            class="action-link action-edit cursor-pointer"
          >
            {{ "batch_management.actions.edit" | translate }}
          </span>
          @if (record.status === 'ACTIVE') {
            <span
              [attr.data-testid]="'batch-action-deactivate-' + record.id"
              (click)="onToggleStatus(record)"
              class="action-link action-edit cursor-pointer"
            >
              {{ "batch_management.actions.deactivate" | translate }}
            </span>
          } @else if (record.status === 'INACTIVE') {
            <span
              [attr.data-testid]="'batch-action-activate-' + record.id"
              (click)="onToggleStatus(record)"
              class="action-link action-edit cursor-pointer"
            >
              {{ "batch_management.actions.activate" | translate }}
            </span>
          }
        }
      </div>
    </ng-template>
    </advanced-data-table>
  </div>

  <p-dialog
    [header]="'batch_management.edit_expiry.title' | translate"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [(visible)]="editExpiryVisible"
    [style]="{ width: '420px' }"
    (onHide)="closeEditExpiry()"
  >
    <div class="flex flex-column gap-3">
      <label class="font-medium">
        {{ "batch_management.edit_expiry.expiry_date" | translate }}
      </label>
      <p-datepicker
        data-testid="batch-edit-expiry-datepicker"
        [(ngModel)]="editExpiryDate"
        dateFormat="dd/mm/yy"
        [minDate]="minExpiryDate"
        [showIcon]="true"
        appendTo="body"
        styleClass="w-full"
      />
    </div>
    <ng-template pTemplate="footer">
      <div class="flex justify-content-end gap-2">
        <app-button
          [testId]="'batch-edit-expiry-cancel'"
          type="secondary"
          [outlined]="true"
          [label]="'batch_management.edit_expiry.cancel' | translate"
          (emitOnClick)="closeEditExpiry()"
        />
        <app-button
          [testId]="'batch-edit-expiry-save'"
          type="info"
          [label]="'batch_management.edit_expiry.save' | translate"
          [loading]="editExpirySaving"
          (emitOnClick)="saveEditExpiry()"
        />
      </div>
    </ng-template>
  </p-dialog>

  <p-toast data-testid="batch-toast"></p-toast>
</div>
